export default {
  parameters: {
    landing_id: "IdQYe",
  },
  newDesign: true,
  title: "Kursus online untuk anak-anak | Kodland",
  downtimeUrl: "https://id6.kodland.tech",
  ageRules: {
    min: 5,
    max: 17,
  },
  startPage: {
    title:
      "Jawablah 3 pertanyaan berikut dan pilih waktu yang sesuai dengan Anda untuk jadwal pelajaran gratis",
    subtitle:
      "✏️ Untuk anak usia 8-17 tahun <br>💻 Membuat proyek IT dasar pertamanya <br>💬 Membahas pengalaman dan hobi anak<br>🌐 Hanya diperlukan komputer dan koneksi internet",
    button: "Daftar kelas gratis",
    image: {
      url: "/welcome/id_yellow_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/id_yellow_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "🙌 Bermain permainan papan",
        "😌 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb",
      ],
    },
    2: {
      question:
        "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    3: {
      title: "Pilih usia anak",
      type: "age",
      subtitle:
        "Pengajar profesional kami akan membantu kamu dan anak mendalami profesi IT",
      button: "",
    },
    4: {
      title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS",
      typeInfo: "congrats",
      subtitle:
        "Klik tombol '📆 Pesan' dan dapatkan pelajarannya",
      button: "📆 Pesan",
    },
    5: {
      title: "Dapatkan kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle: "",
      button: "Lanjutkan 🔥",
    },
    6: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    7: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    8: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda  📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    9: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
